import { BluePrintUser } from './user';
import { APIResponse } from './response';

export class LoginFormErrorMessages {
  username: string;
  password: string;
}

export class AddUserData extends BluePrintUser {
  password: string;
  password_confirmation: string;
  account_type: string;
}

export class EditUserData extends BluePrintUser {
  id: string;
  fullname: string;
  email: string;
  username: string;
  account_status: string;
}

export class EditProfileData extends BluePrintUser {
  old_password: string;
  new_password: string;
  password_confirmation: string;
  user_id: string;
}

export class LoginData {
  username: string;
  password: string;
}

export class TakeTicketLogData {
  Log: {
    taken_by: string;
  };
  status: string;
  ticket_id: string;
}

export class AssignTicketLogData {
  Log: {
    assigned_to: string;
    assigned_by: string;
  };
  status: string;
  ticket_id: string;
}

export class LabelAssignLogData extends TakeTicketLogData {
  Log: {
    taken_by: string;
    assigned_to: string;
    assigned_by: string;
  };
}

export class ChangeDivisionLogData {
  ticket_id: string;
  type: string;
  Log: {
    set_division_by: string;
    division: string;
  };
}

export class ChangeLabelLogData {
  ticket_id: string;
  status: string;
  Log: {
    labelled_by: string;
    label_value: number;
  };
}

export class SolveTicketLogData {
  ticket_id: string;
  marked_solved_by: string;
  status: string;
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/models/form-data.ts